import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import ProtectedRoute from './protectedRoutes';
import { history } from '../Redux/Store';

import AuthPage from '../Components/Login/login';
import Dashboard from '../Components/Dashboard';
import UserManagement from '../Components/UserManagement';
import AddUser from '../Components/UserManagement/addUser';
import UpdateUser from '../Components/UserManagement/updateUser';
import UserInfo from '../Components/UserManagement/userInfo';
import JobsManagement from '../Components/Jobs';
import JobsManagementRequest from '../Components/JobsRequest';
import JobInfo from '../Components/Jobs/info';
import JobInfoReport from '../Components/CustomerJobReports/info';
import MasterManagement from '../Components/Masters';
import AddMaster from '../Components/Masters/add';
import UpdateMaster from '../Components/Masters/update';
import MasterInfo from '../Components/Masters/info';
import AddProcessCosts from '../Components/ProcessCosts/add';
import ManageProcessCosts from '../Components/ProcessCosts/manage';
import UpdateProcessCost from '../Components/ProcessCosts/update';
import ReportsManagement from '../Components/Reports';
import ChangePassword from '../Components/Login/changePassword';
import Localization from '../Components/Localization';
import Notifications from '../Components/Notifications';
import DeliveryManagement from '../Components/Delivery';
import JobSLA from '../Components/JobSLA';
import CustomerJobReports from '../Components/CustomerJobReports';
import Refunds from '../Components/Refunds';
import Sort from '../Components/Masters/sort';
import AdditionalPayments from '../Components/AdditionalPayments/additionalPayments';
import FlyerNotification from '../Components/FlyerNotification/flyerNotification';
import RefundInfo from '../Components/Refunds/refundInfo';
import AdditionalPaymentsPage from '../Components/AdditionalPaymentsPage';
import CspInfo from '../Components/UserManagement/cspInfo';
import PaymentLink from '../Components/PaymentLink/paymentLink';
import CustomerManagement from '../Components/CustomerManagement';
import AddCustomer from '../Components/CustomerManagement/addCustomer';
import UpdateCustomer from '../Components/CustomerManagement/updateCustomer';
import CustomerInfo from '../Components/CustomerManagement/CustomerInfo';
import AffiliateAgent from '../Components/AffiliateAgent/AffiliateAgent';
import CorporateJobs from '../Components/CorporateJobs/corporateJobs';
import CorporateJobsDetail from '../Components/CorporateJobs/corporateJobsDetail';
import AffiliateAgentInfo from '../Components/AffiliateAgent/AffiliateAgentInfo';
import AccessDeniedAlert from '../Components/Ui/403';
import EidAppointmentDetails from '../Components/EidAppointmentDetails/eidAppointmentDetails';

import EditEidAppointment from '../Components/EidAppointmentDetails/editEidAppointment';

import ConsultancyPaymentLink from '../Components/ConsultancyPaymentLink/consultancyPaymentLink';
import SlotSettings from '../Components/SlotSettings';

const Routes = () => (
    <BrowserRouter>
        <Switch history={history}>
            <Route exact path="/" component={AuthPage} />
            <Route exact path="/forgot-password" component={AuthPage} />
            <Route exact path="/access-denied" component={AccessDeniedAlert} />
            <ProtectedRoute exact path="/dashboard" loggedUser={true} component={Dashboard} />
            <ProtectedRoute exact path="/jobs" loggedUser={true} component={JobsManagement} />
            <ProtectedRoute exact path="/jobs-request" loggedUser={true} component={JobsManagementRequest} />
            <ProtectedRoute exact path="/notifications" loggedUser={true} component={Notifications} />
            <ProtectedRoute exact path="/jobs/:jobID" loggedUser={true} component={JobInfo} />
            <ProtectedRoute exact path="/users" loggedUser={true} component={UserManagement} />
            <ProtectedRoute exact path="/user/add" loggedUser={true} component={AddUser} />
            <ProtectedRoute exact path="/user/update" loggedUser={true} component={UpdateUser} />
            <ProtectedRoute exact path="/user/info" loggedUser={true} component={UserInfo} />
            <ProtectedRoute exact path="/user/csp_info" loggedUser={true} component={CspInfo}/>             
            <ProtectedRoute exact path="/customers" loggedUser={true} component={CustomerManagement} />
            <ProtectedRoute exact path="/customer/add" loggedUser={true} component={AddCustomer} />
            <ProtectedRoute exact path="/customer/update" loggedUser={true} component={UpdateCustomer} />
            <ProtectedRoute exact path="/customer/info" loggedUser={true} component={CustomerInfo} />
            <ProtectedRoute exact path="/master/manage/:type" loggedUser={true} component={MasterManagement} />
            <ProtectedRoute exact path="/master/add/:type" loggedUser={true} component={AddMaster} />
            <ProtectedRoute exact path="/master/update/:type" loggedUser={true} component={UpdateMaster} />
            <ProtectedRoute exact path="/master/info/:type" loggedUser={true} component={MasterInfo} />
            <ProtectedRoute exact path="/master/process-cost/manage" loggedUser={true} component={ManageProcessCosts} />
            <ProtectedRoute exact path="/master/process-cost/add" loggedUser={true} component={AddProcessCosts} />
            <ProtectedRoute exact path="/master/process-cost/update" loggedUser={true} component={UpdateProcessCost} />
            <ProtectedRoute exact path="/reports" loggedUser={true} component={ReportsManagement} />
            <ProtectedRoute exact path="/change-password" loggedUser={true} component={ChangePassword} />
            <ProtectedRoute exact path="/localization" loggedUser={true} component={Localization} />
            <ProtectedRoute exact path="/delivery" loggedUser={true} component={DeliveryManagement} />
            <ProtectedRoute exact path="/sla_sequence" loggedUser={true} component={JobSLA} />
            <ProtectedRoute exact path="/customer_job_reports" loggedUser={true} component={CustomerJobReports} />
            <ProtectedRoute exact path="/affiliat-agent-info/:id" loggedUser={true} component={AffiliateAgentInfo} />
            <ProtectedRoute exact path="/customer_job_reports/:jobID" loggedUser={true} component={JobInfoReport} />
            <ProtectedRoute exact path="/refunds" loggedUser={true} component={Refunds} />
            <ProtectedRoute exact path="/refunds/:id" loggedUser={true} component={RefundInfo} />
            <ProtectedRoute exact path="/master/sort" loggedUser={true} component={Sort} />
            <ProtectedRoute ProtectedRoute exact path="/additional-payments-type" loggedUser={true} component={AdditionalPayments} />
            <ProtectedRoute ProtectedRoute exact path="/flyerNotification" loggedUser={true} component={FlyerNotification} />
            <ProtectedRoute ProtectedRoute exact path="/additional-payments-page" loggedUser={true} component={AdditionalPaymentsPage} />
            <ProtectedRoute ProtectedRoute exact path="/payment-link" loggedUser={true} component={PaymentLink} />
            <ProtectedRoute ProtectedRoute exact path="/affiliate-agent" loggedUser={true} component={AffiliateAgent} />
            <ProtectedRoute ProtectedRoute exact path="/corporate-jobs" loggedUser={true} component={CorporateJobs} />
            <ProtectedRoute ProtectedRoute exact path="/corporate-jobs/:id" loggedUser={true} component={CorporateJobsDetail} />
            <ProtectedRoute ProtectedRoute exact path="/eid-appointment-details" loggedUser={true} component={EidAppointmentDetails} />

            <ProtectedRoute ProtectedRoute exact path="/eid-appointment-details/edit/:id" loggedUser={true} component={EditEidAppointment} />

            <ProtectedRoute ProtectedRoute exact path="/consultancy-payment-link" loggedUser={true} component={ConsultancyPaymentLink} />

            <ProtectedRoute exact path="/slot-settings" loggedUser={true} component={SlotSettings} />

        </Switch>
    </BrowserRouter>
);

export default Routes;